import { getChildNodes } from './getChildNodes';
const cache = new WeakMap();
export function getItemCount(collection) {
    const cachedCount = cache.get(collection);
    if (cachedCount != null) {
        return cachedCount;
    }
    let count = 0;
    const countItems = (items)=>{
        // eslint-disable-next-line no-restricted-syntax
        for (const item of items){
            if (item.type === 'section') {
                countItems(getChildNodes(item, collection));
            } else {
                count++;
            }
        }
    };
    countItems(collection);
    cache.set(collection, count);
    return count;
}

//# sourceMappingURL=getItemCount.js.map